import { FILTER } from '../shared/constants';
import IndustryFilter from './IndustryFilter';
import BrandFilter from './BrandFilter';
import TagsFilter from './TagsFilter';

export const STATIC_FILTERS = [
    FILTER.BRAND_NAME,
    FILTER.INDUSTRY,
    FILTER.LOGO_ELEMENTS,
];

export const FILTERS_MAP = {
    [FILTER.BRAND_NAME]: BrandFilter,
    [FILTER.INDUSTRY]: IndustryFilter,
    [FILTER.LOGO_ELEMENTS]: TagsFilter,
};
